'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroFormatter = require('./NitroFormatter');

var _NitroFormatter2 = _interopRequireDefault(_NitroFormatter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroFormatter2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-formatter/index.js
// module id = 235
// module chunks = 4